import TourTooltip from 'elements/tooltip/TourTooltip'
import { TourConfigType } from 'persistentContent/tours/types'
import { useTranslate } from 'ra-core'
import { FC } from 'react'

const StepTooltip: FC = (props) => {
  const translate = useTranslate()
  return (
    <TourTooltip
      title={translate('Voice Mode')}
      subtext={translate(
        'Click the microphone to talk to Ada. You can have a natural conversation and Ada will understand your voice commands.'
      )}
      {...props}
    />
  )
}

const VoiceButton: TourConfigType = {
  spotlights: [{ targetId: 'Ada-Voice-Button', autoScroll: true }],
  tooltips: [
    {
      targetId: 'Ada-Voice-Button',
      placement: 'top',
      component: StepTooltip,
      options: { style: { marginBottom: 10 } },
    },
  ],
}

export default VoiceButton

